// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSortAscendingOutlinedSvg from "@fishx/icons-svg/es/asn/PSortAscendingOutlined";
import FishxIcon from '../components/FishxIcon';

var PSortAscendingOutlined = function PSortAscendingOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSortAscendingOutlinedSvg
  }));
};

PSortAscendingOutlined.displayName = 'PSortAscendingOutlined';
export default React.forwardRef(PSortAscendingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSortAscendingOutlined.js
// module id = 3650
// module chunks = 0